import { useState } from 'react';

export type CommentableDraftOptions = Partial<{
  onStartDrafting(): unknown;
  onStopDrafting(): unknown;
}>;

export function useCommentableDraft(options?: CommentableDraftOptions) {
  const [drafting, setDrafting] = useState(false);

  function startDrafting() {
    options?.onStartDrafting?.();
    return setDrafting(true);
  }

  function stopDrafting() {
    options?.onStopDrafting?.();
    return setDrafting(false);
  }

  return {
    drafting,
    startDrafting,
    stopDrafting,
  };
}
